




























































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import Dish, { DishStatus } from "@/models/Dish";
import dishesService from "@/services/dishes-service";
import DishesRequestFilter from "../models/DishesRequestFilter";

@Component
export default class Dishes extends Vue {
  @Prop()
  categoryId!: number;

  dishes: Dish[] = [];
  currentDish: Dish = new Dish();
  statusSheet = false;

  async setStatusAsync(dish: Dish, status: DishStatus) {
    if (this.currentDish) {
      this.currentDish.status = status;
      this.statusSheet = false;
    }
  }

  async setStatusAvailableAsync(dish: Dish) {
    await dishesService.updateDisabled(dish.uid, 0);
    await this.loadAsync(this.categoryId);
  }

  async setStatusCurrentlyUnavailableAsync(dish: Dish) {
    await dishesService.updateDisabled(dish.uid, 1);
    await this.loadAsync(this.categoryId);
  }

  async setStatusIndefinitelyUnavailableAsync(dish: Dish) {
    await this.setStatusAsync(dish, DishStatus.IndefinitelyUnavailable);
  }

  async openStatusSheetAsync(dish: Dish) {
    this.currentDish = dish;
    this.statusSheet = true;
  }

  async loadAsync(categoryId: number) {
    this.dishes = (await dishesService.findAllAsync(categoryId)).items;
  }

  async mounted() {
    await this.loadAsync(this.categoryId);
  }
}
